<template>
  <v-container fluid class="width-80">
    <v-layout>
      <v-flex>
        <h3 class="font-weight-700 mb-4 font-size-24 custom-headline color-custom-blue">
          Integrations
        </h3>
      </v-flex>
      <v-flex class="text-right">
        <v-btn depressed class="custom-grey-border custom-bold-button" v-on:click="goBack">
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </v-flex>
    </v-layout>
    <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
      style="max-height: 70vh; position: relative">
      <v-card flat class="custom-grey-border remove-border-radius mt-4">
        <v-card-title class="headline grey lighten-4">
          <v-row>
            <v-col md="12" class="py-0 my-auto">
              <h3 class="font-weight-700 custom-headline color-custom-blue" style="margin: 3.5px 0px">
                Configuration
              </h3>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="p-6 font-size-16">
          <v-row v-if="false">
            <v-col md="2">
              <v-img :lazy-src="$defaultImage" :src="$assetURL('media/logos/google-calendar.png')" max-height="100"
                contain position="center center"></v-img>
            </v-col>
            <v-col md="10" class="setting-configuration">
              <div>
                <h4 class="font-weight-bold color-custom-blue">
                  Google Calendar
                </h4>
                <p>
                  Integrate with Google Calendar - Automatic sync all visits and
                  reminders.
                </p>
              </div>
              <div>
                <v-btn depressed v-if="googleConnected" v-on:click="googleDisconnect" :loading="googleLoading"
                  :disabled="googleLoading || pageLoading" small class="text-white" color="cyan">
                  <span class="font-size-16 font-weight-600">Disconnect</span>
                </v-btn>
                <v-btn v-else depressed v-on:click="googleConnect" small class="text-white" color="cyan"
                  :loading="googleLoading" :disabled="googleLoading || pageLoading">
                  <span class="font-size-16 font-weight-600">Connect</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-divider v-if="false" class="my-6"></v-divider>

          <!-- Info-Tech Accounting Gateway Integration -->
          <v-row>
            <v-col md="2">
              <v-img :lazy-src="$defaultImage" :src="$assetURL('media/logos/infotech.svg')" max-height="80" contain
                position="center center"></v-img>
            </v-col>
            <v-col md="10" class="setting-configuration">
              <div>
                <h4 class="font-weight-bold color-custom-blue">
                  Info-Tech Accounting
                  <v-chip v-if="infotechConnected" small color="success" class="ml-2 font-weight-600" label>
                    Connected: {{ infotechOrgName || 'Active' }}
                  </v-chip>
                </h4>
                <p>
                  Integrate with Info-Tech Accounting External API Gateway - Seamlessly sync Customers, Invoices, and
                  Receive Money Direct Payments.
                </p>
              </div>
              <div>
                <v-btn depressed v-if="infotechConnected" v-on:click="infotechDisconnect" :loading="infotechLoading"
                  :disabled="infotechLoading || pageLoading" small class="text-white" color="red">
                  <span class="font-size-16 font-weight-600">Disconnect</span>
                </v-btn>
                <v-btn v-else depressed v-on:click="infotechConnect" small class="text-white" color="blue darken-3"
                  :loading="infotechLoading" :disabled="infotechLoading || pageLoading">
                  <span class="font-size-16 font-weight-600">Connect Info-Tech</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </perfect-scrollbar>
  </v-container>
</template>

<script>
import { GET } from "@/core/services/store/request.module";

export default {
  data() {
    return {
      googleConnected: false,
      googlePopup: null,
      googleTimeInterval: null,
      googleLoading: false,
      infotechConnected: false,
      infotechOrgName: "",
      infotechPopup: null,
      infotechTimeInterval: null,
      infotechLoading: false,
      pageLoading: false,
    };
  },
  methods: {
    googleConnect() {
      const _this = this;
      _this.googleLoading = true;
      _this.$store
        .dispatch(GET, { url: "google/calendar/url" })
        .then(({ data }) => {
          _this.googleConnectPopup(data.url);
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    googleDisconnect() {
      const _this = this;
      _this.googleLoading = true;
      _this.$store
        .dispatch(GET, { url: "google/calendar/disconnect" })
        .then(() => {
          _this.googleConnected = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.googleLoading = false;
        });
    },
    googleConnectPopup(url) {
      let left = screen.width / 2 - 536 / 2;
      let top = screen.height / 2 - 634 / 2;
      this.googlePopup = window.open(
        url,
        "",
        "resizable=yes,top=" + top + ",left=" + left + ",width=536,height=634"
      );
      this.watchGooglePopup();
    },
    checkGoogleStatus() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "google/calendar/status" })
        .then(({ data }) => {
          if (data.status) {
            _this.googleConnected = true;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.googleLoading = false;
        });
    },
    watchGooglePopup() {
      const _this = this;
      clearInterval(_this.googleTimeInterval);
      _this.googleTimeInterval = setInterval(function () {
        if (_this.googlePopup && _this.googlePopup.closed) {
          _this.googlePopup = null;
          clearInterval(_this.googleTimeInterval);
          setTimeout(function () {
            _this.checkGoogleStatus();
          }, 2000);
        }
      }, 1000);
    },

    // Info-Tech Integration Methods
    infotechConnect() {
      const _this = this;
      _this.infotechLoading = true;
      _this.$store
        .dispatch(GET, { url: "infotech/url" })
        .then((response) => {
          const res = response && response.data ? response.data : response;
          const targetUrl = (res && res.url) ? res.url : ((response && response.url) ? response.url : null);
          if (targetUrl) {
            _this.infotechConnectPopup(targetUrl);
          } else {
            _this.logError((res && res.message) || "Failed to get authorization URL.");
            _this.infotechLoading = false;
          }
        })
        .catch((error) => {
          _this.logError(error);
          _this.infotechLoading = false;
        });
    },
    infotechDisconnect() {
      const _this = this;
      _this.infotechLoading = true;
      _this.$store
        .dispatch(GET, { url: "infotech/disconnect" })
        .then(() => {
          _this.infotechConnected = false;
          _this.infotechOrgName = "";
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.infotechLoading = false;
        });
    },
    infotechConnectPopup(url) {
      let left = screen.width / 2 - 600 / 2;
      let top = screen.height / 2 - 700 / 2;
      this.infotechPopup = window.open(
        url,
        "InfoTechAuthorization",
        "resizable=yes,top=" + top + ",left=" + left + ",width=600,height=700"
      );
      this.watchInfotechPopup();
    },
    checkInfotechStatus() {
      const _this = this;
      _this.infotechLoading = true;
      _this.$store
        .dispatch(GET, { url: "infotech/status" })
        .then((response) => {
          const res = response && response.data ? response.data : response;
          const details = res && res.data ? res.data : res;
          if ((res && res.status === true) || (details && details.connected === true)) {
            _this.infotechConnected = true;
            _this.infotechOrgName = (details && details.organization_name) ? details.organization_name : "";
          } else {
            _this.infotechConnected = false;
            _this.infotechOrgName = "";
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.infotechLoading = false;
        });
    },
    watchInfotechPopup() {
      const _this = this;
      clearInterval(_this.infotechTimeInterval);
      _this.infotechTimeInterval = setInterval(function () {
        if (_this.infotechPopup && _this.infotechPopup.closed) {
          _this.infotechPopup = null;
          clearInterval(_this.infotechTimeInterval);
          setTimeout(function () {
            _this.checkInfotechStatus();
          }, 1500);
        }
      }, 1000);
    },
    handleMessageEvent(event) {
      if (event && event.data && event.data.type === 'INFOTECH_CONNECTED') {
        this.checkInfotechStatus();
      }
    },
  },
  mounted() {
    /* this.checkGoogleStatus(); */
    this.checkInfotechStatus();
    window.addEventListener('message', this.handleMessageEvent);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessageEvent);
    clearInterval(this.googleTimeInterval);
    clearInterval(this.infotechTimeInterval);
  },
};
</script>
